import ScrollReveal from "./ScrollReveal";
import { Check } from "lucide-react";

const VINYL_IMAGE = "/images/covering.png";

const BENEFITS = [
  "Intervention rapide (environ 2 jours)",
  "Sans gros travaux ni démolition",
  "Résultat propre, esthétique et durable",
];

export default function SolutionSection() {
  return (
    <section data-testid="solution-section" className="py-24 lg:py-36 bg-[#0273DB]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <ScrollReveal>
            <div className="order-2 lg:order-1">
              <img
                src={VINYL_IMAGE}
                alt="Application de vinyle sur meuble de cuisine"
                className="w-full rounded-3xl shadow-2xl shadow-black/20 object-cover aspect-[4/3]"
              />
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.15}>
            <div className="order-1 lg:order-2 space-y-6">
              <div className="inline-flex items-center gap-2 bg-white/15 text-white px-4 py-1.5 rounded-full text-sm font-semibold backdrop-blur-sm">
                Notre solution
              </div>
              <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">
                La solution Vinylux
              </h2>
              <p className="text-base sm:text-lg text-white/70 leading-relaxed">
                Grâce au covering (film adhésif haut de gamme), nous transformons
                vos meubles existants avec un rendu moderne et durable.
              </p>
              <ul className="space-y-3">
                {BENEFITS.map((b) => (
                  <li key={b} className="flex items-start gap-3">
                    <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-3.5 h-3.5 text-[#0284FC]" strokeWidth={3} />
                    </div>
                    <span className="text-white/90 font-medium">{b}</span>
                  </li>
                ))}
              </ul>
              <p className="text-sm text-white/50 leading-relaxed">
                Nous utilisons des films professionnels résistants à la chaleur,
                à l'humidité et à l'usure du quotidien.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
